import React from 'react'
import Navbar from '../inc/Navbar'
import Slider from '../inc/Slider'
import "./Home.css";
import Project from './Project';
import Gallery from './Gallery';
import landsalekriahnagar from "../images/office (2).jpeg";
import HomeButton from './HomeButton';
import Popup from './Popup';
import GoogleMap from './GoogleMap';
import OngoingProject from './OngoingProject';

function Home() {
    return (
        <div>
            <Navbar />
            <br />
            <br />

            <br />
            <div className="album py-0">
                <div className="container">
                    <h5>SRG Complex</h5>
                </div>
            </div>
            <Slider />
            <HomeButton />
            <div className='bhkvilla'>
                <marquee><h4 className='mt-2' style={{ color: "white" }} >Welcome To SRG Complex | Chadmari, Krishnagar, Pin - 741103,

                    Dist.- Nadia, West Bengal | India  </h4></marquee>
            </div>
            <br />
            
            <Project />

            <br />
<OngoingProject/>

             <div className="album py-0">
                <div className="container">
      <iframe
      width="100%"
        height="315"
        src="https://www.youtube.com/embed/C25OW4lIqBs"
        title="YouTube video player"
        frameBorder="0"
        allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
        allowFullScreen
      ></iframe>
      </div>
      </div>
      <br/>
      <Popup/>
            <div className="album py-0">
                <div className="container">

                    <div className="card-body">
                        <div className='welcometext'>
                            <h1 style={{ color: "#B80000" }} className="card-title mb-0"><b>🏡 SRG Complex, Krishnanagar – Where Modern Living Begins</b></h1>
                            <div className="col-md-2">
                                <hr style={{ color: "#1D4D93" }} />
                            </div>
                        </div>
                        <div className="album py-0">
                            <div className="container">
                                <div className="row">

                                    <div className="col-md-7 mt-3">
                                        <div className='mission'>

                                            <p className='justify mb-2'>Welcome to SRG Complex, one of the largest and most prestigious residential projects at Chandmari, Krishnanagar. Spread across a thoughtfully planned layout, the project offers 100 premium residential plots along with beautifully designed 3 BHK and 4 BHK villas.</p>
                                            <p className='justify mb-1'>Experience a majestic lifestyle with modern amenities, lush surroundings, and a peaceful living environment crafted for comfort and elegance.</p>
                                            <p className='justify mb-1'>📍 Prime Location Advantage
                                                Just 2 km from Krishnanagar Bus Stand, SRG Complex ensures excellent connectivity while offering a calm, upscale residential atmosphere.</p>
                                            <p className='justify mb-3'>✨ A futuristic residential destination
                                                Unmatched in design and concept, SRG Complex sets a new benchmark in Nadia District—a living experience never seen before</p>

                                            <h6 style={{ color: "#1D4D93" }}><b>SRG Complex – Live Grand. Live Modern. Live Better.</b></h6>
                                        </div>
                                    </div>
                                    <div className="col-md-5 mt-3">

                                        <img src={landsalekriahnagar} className="card-img-top" alt="maingatesrgcomplex" />


                                    </div>





                                </div>
                            </div>
                        </div>
                        <br />






                    </div>
                </div>
            </div>
            <div className="album py-0">
                <div className="container">
                    <h1 style={{ color: "#B80000" }}><b>SRG COMPLEX Gallery </b></h1>
                </div>
            </div>
            <Gallery />
            <br />
            <div style={{ color: "white", padding: "14px;", margin: 10 }} className="fixed-bottom "> <a style={{ color: "white" }} href="tel: 8918782294" className="srgcomplexkrishnagar" > <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-phone" viewBox="0 0 16 16">
                <path d="M11 1a1 1 0 0 1 1 1v12a1 1 0 0 1-1 1H5a1 1 0 0 1-1-1V2a1 1 0 0 1 1-1h6zM5 0a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h6a2 2 0 0 0 2-2V2a2 2 0 0 0-2-2H5z" />
                <path d="M8 14a1 1 0 1 0 0-2 1 1 0 0 0 0 2z" />
            </svg> Call Us <div className="spinner-grow text-light spinner-grow-sm" role="status">
                    <span className="visually-hidden"> Loading...</span>
                </div> </a></div>
                <GoogleMap/>
                <br/>

        </div>
    )
}

export default Home